import { Controller } from "@hotwired/stimulus"

// Handles the Razorpay Standard Checkout flow:
// 1. Intercepts the pay button click
// 2. Creates a Razorpay order server-side
// 3. Opens the Razorpay checkout widget
// 4. On payment success, submits the verification form
export default class extends Controller {
  static targets = ["button", "verifyForm"]
  static values  = {
    createOrderUrl: String,
    verifyUrl:      String,
    planId:         String,
    startDate:      String,
    nextMonth:      String,
    csrfToken:      String
  }

  async pay(event) {
    event.preventDefault()

    const btn = this.buttonTarget
    btn.disabled = true
    btn.textContent = "Please wait…"

    try {
      const orderData = await this.#createOrder()
      this.#openCheckout(orderData)
    } catch (err) {
      console.error("[razorpay-checkout]", err)
      btn.disabled = false
      btn.textContent = "Confirm & Pay"
      alert("Could not initiate payment. Please try again.")
    }
  }

  async #createOrder() {
    const body = new URLSearchParams({
      plan_id:    this.planIdValue,
      start_date: this.startDateValue,
      next_month: this.nextMonthValue
    })

    const resp = await fetch(this.createOrderUrlValue, {
      method:  "POST",
      headers: {
        "Content-Type":  "application/x-www-form-urlencoded",
        "X-CSRF-Token":  this.csrfTokenValue,
        "Accept":        "application/json"
      },
      body
    })

    if (!resp.ok) throw new Error(`create_order failed: ${resp.status}`)
    return resp.json()
  }

  #openCheckout(data) {
    const options = {
      key:         data.key_id,
      amount:      data.amount,
      currency:    data.currency,
      order_id:    data.order_id,
      name:        data.studio_name,
      description: data.description,
      prefill:     { name: data.user_name, email: data.user_email },
      theme:       { color: "#10b981" },

      handler: (response) => {
        this.#submitVerification(response, data)
      },

      modal: {
        ondismiss: () => {
          const btn = this.buttonTarget
          btn.disabled = false
          btn.textContent = "Confirm & Pay"
        }
      }
    }

    const rzp = new window.Razorpay(options)
    rzp.open()
  }

  #submitVerification(response, orderData) {
    const form = this.verifyFormTarget

    this.#addHidden(form, "razorpay_payment_id", response.razorpay_payment_id)
    this.#addHidden(form, "razorpay_order_id",   response.razorpay_order_id)
    this.#addHidden(form, "razorpay_signature",  response.razorpay_signature)
    this.#addHidden(form, "plan_id",      orderData.plan_id)
    this.#addHidden(form, "valid_from",   orderData.valid_from)
    this.#addHidden(form, "valid_till",   orderData.valid_till)
    this.#addHidden(form, "amount_cents", String(orderData.amount_cents))

    form.submit()
  }

  #addHidden(form, name, value) {
    const input = document.createElement("input")
    input.type  = "hidden"
    input.name  = name
    input.value = value
    form.appendChild(input)
  }
}
